import React from 'react';
import { Container, Paper, Stack, Group, Text, Badge } from '@mantine/core';
import { IconUsers } from '@tabler/icons-react';
import UserManagement from '../../features/admin/users/UserManagement';

/**
 * Coordinator User Management Page
 * 
 * Provides access to user management for coordinators
 * Includes the existing UserManagement component
 */
const CoordinatorUserManagement: React.FC = () => {
  return (
    <Container size="xl" py="md">
      <Stack gap="md">
        {/* Header */}
        <Paper p="md" radius="md" withBorder>
          <Group justify="space-between">
            <Group gap="sm">
              <IconUsers size={24} />
              <Text fw={700} size="xl">User Management</Text>
            </Group>
            <Badge size="lg" variant="light" color="blue">
              Coordinator Access
            </Badge>
          </Group>
        </Paper>

        {/* User Management Interface */}
        <UserManagement />
      </Stack>
    </Container>
  );
};

export default CoordinatorUserManagement;
